module.exports = __webpack_public_path__ + "img/mall01.3a79d4df.png";